import React, {useCallback, useContext, useEffect, useState} from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import BadgeTwoToneIcon from "@mui/icons-material/BadgeTwoTone";
import SaveTwoToneIcon from "@mui/icons-material/SaveTwoTone";
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import {AnagraficaContext, AppContext} from "../../../../App";
import {getAnagraficaById, updateAnagrafica} from "../../../../services/AnagraficaServices";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {resetAnagrafica} from "../../interviste/intervista/utils/ResetUtils";
import CompanyFieldSection from "./CompanyFieldSection";

const AnagraficaReferenteDetailSection = ({classes, idSoggetto}) => {
	const anagraficaContext = useContext(AnagraficaContext);
	const appContext = useContext(AppContext);
	const methods = useForm({mode: "onChange"});
	const [submit, setSubmit] = useState(false);
	const [isResetAnagrafica, setisResetAnagrafica] = useState(false);

	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateAnagrafica(getAnaGraficaApi({
			...anagraficaContext.state.anagrafica,
			...data,
		}), idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.state.anagrafica, anagraficaContext.dispatch]);

	useEffect(() => {
		if (idSoggetto) {
			getAnagraficaById(idSoggetto, anagraficaContext.dispatch);
		}
	}, [idSoggetto, anagraficaContext.dispatch]);

	useEffect(() => {
		if (!isResetAnagrafica && !anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "") {
			methods.reset(resetAnagrafica(anagraficaContext.state.anagrafica));
			setisResetAnagrafica(true);
		}
	}, [
		anagraficaContext.state.anagrafica,
		anagraficaContext.state.loadingGetAnagrafica,
		anagraficaContext.state.errorGetAnagrafica,
		methods,
		isResetAnagrafica,
	]);

	useEffect(() => {
		if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Anagrafica aggiornata correttamente", appContext.dispatch);
		} else if (submit && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica !== "") {
			setSubmit(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch);
		}
	}, [
		submit,
		anagraficaContext.state.loadingUpdateAnagrafica,
		anagraficaContext.state.errorUpdateAnagrafica,
		appContext.dispatch,
	]);

	return (
		<section className={classes.panel}>
			<header className={classes.panelHeader}>
				<div>
					<Typography className={classes.panelTitle}>Dati referente</Typography>
					<Typography className={classes.panelSubtitle}>
						Anagrafica e recapiti del referente collegato all'azienda.
					</Typography>
				</div>
			</header>

			<FormProvider {...methods}>
				<form onSubmit={methods.handleSubmit(onSubmit)}>
					<div className={classes.sectionStack}>
						<CompanyFieldSection
							classes={classes}
							icon={<BadgeTwoToneIcon fontSize="small"/>}
							subtitle="Documento, recapiti e dati anagrafici del referente."
							title="Anagrafica"
						>
							<Grid container spacing={2.5} className={classes.legacyFormGrid}>
								{anagraficaContext.state.loadingGetAnagrafica && (
									<Grid size={12}>
										<Skeleton className={classes.skeletonCard} variant="rounded"/>
									</Grid>
								)}
								{!anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica !== "" && (
									<Grid size={12}>
										<Alert severity="error" sx={{borderRadius: 4}}>
											Non e stato possibile recuperare l'anagrafica del referente.
										</Alert>
									</Grid>
								)}
								{!anagraficaContext.state.loadingGetAnagrafica && anagraficaContext.state.errorGetAnagrafica === "" && (
									<AnagraficaCompleta
										classes={classes}
										fieldSize="small"
										intro="false"
										moreInfo
										selectClassName={classes.companySelectField}
										solidField
										solidSelect
										anagrafica={anagraficaContext.state.anagrafica}
									/>
								)}
							</Grid>
						</CompanyFieldSection>
					</div>

					<div className={classes.actionRow}>
						<Button
							className={classes.actionButton}
							disabled={submit}
							disableElevation
							onClick={methods.handleSubmit(onSubmit)}
							size="small"
							startIcon={submit ? <CircularProgress size={16}/> : <SaveTwoToneIcon/>}
							type="submit"
							variant="contained"
						>
							Aggiorna anagrafica
						</Button>
					</div>
				</form>
			</FormProvider>
		</section>
	);
};

export default React.memo(AnagraficaReferenteDetailSection);
